<template>
    <li
        v-for="(subItem, index) in item.subMenu"
        :key="subItem.title"
        class="w-full rounded-2xl cursor-pointer group transition-all xl:text-gray-100 text-brand-300 hover:bg-brand-transparent-10 hover:text-brand-200"
        @mouseenter="emit('hover:item', subItem)"
    >
        <div :to="subItem.link" class="flex items-center w-full justify-between" @click="handleLinkClick(subItem)">
            <div class="flex space-x-2 p-2 items-center">
                <div>
                    <p class="text-body-md lg:text-brand-300 font-medium">
                        {{ subItem.title }}
                    </p>
                    <span class="text-body-sm text-gray-500">{{ subItem.description }}</span>
                </div>
            </div>

            <Icon v-if="hasMegaMenu && useDevice().isDesktop" name="tabler:chevron-right" size="24px" class="mr-3" />
        </div>
    </li>
</template>

<script setup lang="ts">
import type { IHeaderLinkItem } from "~/types/components/header.type";

interface IProps {
    item: IHeaderLinkItem;
    hasMegaMenu?: boolean;
}

const emit = defineEmits(["click:item", "hover:item"]);
defineProps<IProps>();

const showMobileMenu = useMobileMenuOpen();
const { isMobile } = useDevice();

const localePath = useLocalePath();

const handleLinkClick = async (item: IHeaderLinkItem) => {
    emit("click:item", item);
    if (item.link) await navigateTo(localePath(item.link as string));

    setTimeout(() => {
        const el = document.querySelector(item.elementId as string);
        el?.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
    }, 1000);
    if (isMobile) {
        showMobileMenu.value = false;
    }
};
</script>
